﻿export enum TenantRole {
    Owner = "Owner",
    Contributor = "Contributor",
    Reader = "Reader",
}
